var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 34.4991C19.5001 35.7591 19.6951 36.9891 20.055 38.1291C14.2951 36.1341 9.94505 30.8391 9.49505 24.6441C9.04505 18.0591 12.84 11.9091 18.975 9.32908C20.5651 8.66908 21.375 9.14908 21.72 9.49408C22.05 9.82408 22.515 10.6191 21.8551 12.1341C21.18 13.6941 20.85 15.3441 20.85 17.0541C20.8651 20.1141 22.0651 22.9491 24.0151 25.1241C21.2701 27.3141 19.5001 30.7041 19.5001 34.4991Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.815 32.58C34.845 36.615 30.135 38.985 25.11 38.985C24.87 38.985 24.63 38.97 24.39 38.955C22.89 38.895 21.435 38.61 20.055 38.13C19.695 36.99 19.5 35.76 19.5 34.5C19.5 30.705 21.27 27.315 24.015 25.125C26.22 27.6 29.385 29.205 32.88 29.355C33.825 29.4 34.77 29.325 35.7 29.16C37.38 28.86 38.055 29.49 38.295 29.895C38.55 30.3 38.82 31.185 37.815 32.58Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.93ceab561b7cb47b44546145bb589e96.svg";
export { ForwardRef as ReactComponent };